<template>
  <v-app>
    <v-app-bar
      color="transparent"
      flat
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Agência 352 Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo.svg"
          transition="scale-transition"
          max-height="60px"
        />
      </div>
    </v-app-bar>

    <v-content>
      <HelloWorld/>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
  .v-application--wrap{
    font-family: 'Montserrat', sans-serif;
    background-image: url('./assets/bg.jpg') !important;
    background-size: cover;
  }
</style>
